import { render, staticRenderFns } from "./ImportPhoto.vue?vue&type=template&id=6d112dce"
import script from "./ImportPhoto.vue?vue&type=script&lang=js"
export * from "./ImportPhoto.vue?vue&type=script&lang=js"
import style0 from "./ImportPhoto.vue?vue&type=style&index=0&id=6d112dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports